import React from "react";

export function ArrowIcon(props: any) {
  return (
    <span
      className={`icon icon-arrow icon-arrow-${
        props.direction ? props.direction : "right"
      }${props.color ? " has-color" : ""}`}
      onClick={props.handleClick ? props.handleClick : () => {}}
    >
      <svg width="16.103" height="10.649" viewBox="0 0 16.103 10.649">
        <g id="Group_87" transform="translate(0 0.707)">
          <path
            id="Path_16"
            d="M287.641,384l4.618,4.618-4.618,4.618"
            transform="translate(-277.57 -384)"
            fill="none"
            stroke={props.color ? props.color : "#D0D3D6"}
            strokeWidth="2"
          />
          <path
            id="Path_35"
            d="M124,21.617h14.088"
            transform="translate(-124 -17)"
            fill="none"
            stroke={props.color ? props.color : "#D0D3D6"}
            strokeWidth="2"
          />
        </g>
      </svg>
    </span>
  );
}

export function LinkIcon(props: any) {
  return (
    <span className={`icon icon-link`}>
      <svg width="16.669" height="16.669" viewBox="0 0 16.669 16.669">
        <g id="link-icon" transform="translate(0 0)">
          <path
            id="Path_700"
            d="M6.1,13.225l-.843.838a1.887,1.887,0,0,1-2.651,0,1.834,1.834,0,0,1,0-2.608l3.1-3.08c.643-.638,1.854-1.577,2.736-.7A1.033,1.033,0,1,0,9.906,6.206c-1.5-1.488-3.716-1.213-5.646.7l-3.1,3.08a3.9,3.9,0,0,0,0,5.539,3.959,3.959,0,0,0,5.561,0l.844-.838A1.033,1.033,0,0,0,6.1,13.225ZM15.513,1.259a3.689,3.689,0,0,0-5.354-.205L9.108,2.1a1.033,1.033,0,1,0,1.456,1.466L11.615,2.52a1.673,1.673,0,0,1,2.443.205,1.833,1.833,0,0,1,0,2.608L10.746,8.619c-1.515,1.5-2.225.8-2.528.5a1.033,1.033,0,1,0-1.455,1.466,3.257,3.257,0,0,0,2.321,1.032A4.548,4.548,0,0,0,12.2,10.085L15.514,6.8a3.9,3.9,0,0,0,0-5.54Z"
            fill={props.color ? props.color : "#D0D3D6"}
          />
        </g>
      </svg>
    </span>
  );
}

export function CloseIcon(props: any) {
  return (
    <span className={`icon icon-close`} onClick={props.handleClick ? props.handleClick : () => {}}>
      <svg width="15.703" height="15.703" viewBox="0 0 15.703 15.703">
        <g id="Group_97" transform="translate(-142.762 -828.095) rotate(45)">
          <line
            id="Line_2"
            y2="16.207"
            transform="translate(697.604 476.5)"
            fill="none"
            stroke={props.color ? props.color : "#D0D3D6"}
            strokeLinecap="round"
            strokeWidth="3"
          />
          <line
            id="Line_3"
            y2="16.207"
            transform="translate(705.707 484.604) rotate(90)"
            fill="none"
            stroke={props.color ? props.color : "#D0D3D6"}
            strokeLinecap="round"
            strokeWidth="3"
          />
        </g>
      </svg>
    </span>
  );
}

export function TwoArrows(props: any) {
  const color = props.color ? props.color : "#d0d3d6";
  return (
    <svg width="11" height="15" viewBox="0 0 11 15">
      <g id="Group_286" data-name="Group 286" transform="translate(0.182)">
        <path
          id="Polygon_1"
          data-name="Polygon 1"
          d="M5.5,0,11,7H0Z"
          transform="translate(-0.182)"
          fill={color}
        />
        <path
          id="Polygon_2"
          data-name="Polygon 2"
          d="M5.5,0,11,6H0Z"
          transform="translate(10.818 15) rotate(180)"
          fill={color}
        />
      </g>
    </svg>
  );
}

export function PlayButton(props: any) {
  return (
    <svg
      id="Group_286"
      className="play-button"
      data-name="Group 286"
      width="50"
      height="50"
      viewBox="0 0 50 50"
    >
      <circle
        id="Ellipse_61"
        data-name="Ellipse 61"
        cx="25"
        cy="25"
        r="25"
        fill="#3c78e6"
      />
      <path
        id="if_icon-play_211876"
        d="M113.191,73.39,97.712,64.178A1.167,1.167,0,0,0,97.106,64a1.109,1.109,0,0,0-1.1,1.112H96V84.237h.006a1.109,1.109,0,0,0,1.1,1.112,1.272,1.272,0,0,0,.623-.189l15.462-9.2a1.674,1.674,0,0,0,0-2.569Z"
        transform="translate(-78.125 -49.799)"
        fill="#f7f5f2"
      />
    </svg>
  );
}

export function CustomFingerprint() {
  return (
    <svg viewBox="0 0 1049.95 610">
      <g
        id="Group_288"
        data-name="Group 288"
        transform="translate(-2182.492 -145.206)"
      >
        <g
          id="Group_280"
          data-name="Group 280"
          transform="translate(2227.768 16.206)"
        >
          <g
            id="Group_255"
            data-name="Group 255"
            transform="translate(-200 79)"
          >
            <path
              id="Path_736"
              data-name="Path 736"
              d="M411.771,0l212.48.5"
              transform="translate(-252.539 405)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="3"
            />
            <path
              id="Path_679"
              data-name="Path 679"
              d="M3681.521,5685.625H3721.3v-.007c.186,0,.371.007.557.007a50,50,0,0,0,0-100c-.186,0-.371,0-.557.007v-.007H2982.418"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
          </g>
          <g
            id="Group_254"
            data-name="Group 254"
            transform="translate(-200 79)"
          >
            <path
              id="Path_681"
              data-name="Path 681"
              d="M3099.156,5535.625H2982.418v200l212.48.959"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_717"
              data-name="Path 717"
              d="M169.208,0H20"
              transform="translate(286.807 255)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="3"
            />
            <path
              id="Path_680"
              data-name="Path 680"
              d="M3681.3,5735.625h39.449v-.014c.372,0,.742.014,1.115.014a99.686,99.686,0,0,0,70.54-29.118"
              transform="translate(-2824.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_682"
              data-name="Path 682"
              d="M3818.336,5662.033a100.083,100.083,0,0,0-96.476-126.408c-.373,0-.743.01-1.115.014v-.014h-408.58"
              transform="translate(-2824.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
          </g>
          <g
            id="Group_258"
            data-name="Group 258"
            transform="translate(-256.191 358.469)"
            opacity="0.3"
          >
            <path
              id="Path_717-2"
              data-name="Path 717"
              d="M132.171,0H20"
              transform="translate(475.261 150.356)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <path
              id="Path_715"
              data-name="Path 715"
              d="M-115.051,629H464.14"
              transform="translate(330.475 -629)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <path
              id="Path_680-2"
              data-name="Path 680"
              d="M3557.3,5706.507h122.878v.011c.28,0,.558-.011.838-.011a74.941,74.941,0,0,1,53.031,21.891"
              transform="translate(-2725.009 -5706.507)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              id="Path_682-2"
              data-name="Path 682"
              d="M3685.914,5535.624a75.24,75.24,0,0,1-72.528,95.031c-.28,0-.559-.007-.838-.01v.01h-739.74"
              transform="translate(-2657.384 -5480.299)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
          <g
            id="Group_253"
            data-name="Group 253"
            transform="translate(-200 79)"
          >
            <path
              id="Path_685"
              data-name="Path 685"
              d="M3441.245,5435.625H2982.418v400l66.883-.047"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_686"
              data-name="Path 686"
              d="M3680.547,5835.6l39.083.028v-.028c.744.008,1.484.028,2.23.028,110.457,0,200-89.543,200-200s-89.543-200-200-200c-.746,0-1.486.02-2.23.028v-.028l-230.079.028"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_737"
              data-name="Path 737"
              d="M263.152,555h108.56"
              fill="none"
              stroke="#3c78e6"
              strokeWidth="3"
            />
          </g>
          <g
            id="Group_262"
            data-name="Group 262"
            transform="translate(-825 2.891)"
            opacity="0.3"
          >
            <path
              id="Path_685-2"
              data-name="Path 685"
              d="M3961.462,5435.625H3607.418V5988.2"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              id="Path_686-2"
              data-name="Path 686"
              d="M3150.785,5988.163l738.617.038v-.038c1.028.011,2.05.038,3.081.038,152.59,0,276.288-123.7,276.288-276.288s-123.7-276.288-276.288-276.288c-1.03,0-2.053.027-3.081.038v-.038l-317.841.038"
              transform="translate(-2366.552 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
          <g
            id="Group_260"
            data-name="Group 260"
            transform="translate(3.203 103.514)"
            opacity="0.3"
          >
            <path
              id="Path_685-3"
              data-name="Path 685"
              d="M3042.424,5435.625H2779.215v350.486s207.114-.029,389.532-.041"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              id="Path_686-3"
              data-name="Path 686"
              d="M3364.547,5786.087l299.989.024v-.024c.652.007,1.3.024,1.954.024a175.243,175.243,0,0,0,0-350.486c-.654,0-1.3.018-1.954.024v-.024l-491.6.024"
              transform="translate(-2971.371 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
          <g
            id="Group_250"
            data-name="Group 250"
            transform="translate(-357.379 -5201.625)"
          >
            <path
              id="Path_718"
              data-name="Path 718"
              d="M1014.893,5785.616l39.488.009v-.021c.557.006,1.113.021,1.672.021a150.022,150.022,0,0,0,39.969-294.616"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_719"
              data-name="Path 719"
              d="M316.611,5485.625h0v300l212.48.184"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_720"
              data-name="Path 720"
              d="M1046.38,5485.646l-729.769-.021"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
          </g>
          <g
            id="Group_259"
            data-name="Group 259"
            transform="translate(-676.768 308.056)"
            opacity="0.3"
          >
            <path
              id="Path_718-2"
              data-name="Path 718"
              d="M399.283,5491.027l547.842-.018v.018c.466,0,.931-.018,1.4-.018a125.46,125.46,0,0,1,33.425,246.38"
              transform="translate(426.682 -5490.856)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              id="Path_719-2"
              data-name="Path 719"
              d="M47.611,5485.778l68.053-.153"
              transform="translate(588.389 -5485.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              id="Path_720-2"
              data-name="Path 720"
              d="M910.384,5485.625H179.268"
              transform="translate(456.732 -5234.606)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
          <g
            id="Group_252"
            data-name="Group 252"
            transform="translate(-200 79)"
          >
            <path
              id="Path_688"
              data-name="Path 688"
              d="M3622.013,5386.625l-639.595-1v500l212.48,2.319"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_721"
              data-name="Path 721"
              d="M12863.814,4414h-37.887"
              transform="translate(-11968.928 -3807)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="3"
            />
            <path
              id="Path_687"
              data-name="Path 687"
              d="M3719.073,5885.625v-.035c.929.01,1.855.035,2.787.035a249.473,249.473,0,0,0,191.741-89.568"
              transform="translate(-2824.186 -5278.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              id="Path_689"
              data-name="Path 689"
              d="M3951.056,5735.631a249.16,249.16,0,0,0,20.8-100.006c0-138.072-111.929-250-250-250-.932,0-1.858.025-2.787.035v-.035h-44.225"
              transform="translate(-2824.186 -5278.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
          </g>
          <g
            id="Group_261"
            data-name="Group 261"
            transform="translate(-776.008 209.156)"
            opacity="0.3"
          >
            <path
              id="Path_688-2"
              data-name="Path 688"
              d="M3244.219,5836.73l-431.561-.1V5387.707l72.037-2.082"
              transform="translate(-2077.418 -5385.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              id="Path_721-2"
              data-name="Path 721"
              d="M13246.459,4414H12825.93"
              transform="translate(-11817.257 -4413.713)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <path
              id="Path_687-2"
              data-name="Path 687"
              d="M3719.073,5796.057v.032c.834-.009,1.666-.032,2.5-.032a223.988,223.988,0,0,1,172.153,80.418"
              transform="translate(-2246.025 -5795.771)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              id="Path_689-2"
              data-name="Path 689"
              d="M3922.839,5385.625a223.71,223.71,0,0,1,18.679,89.79c0,123.966-100.495,224.46-224.46,224.46-.837,0-1.668-.022-2.5-.032v.032H3455.848"
              transform="translate(-2241.507 -5250.667)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
          <g
            id="Group_251"
            data-name="Group 251"
            transform="translate(-200 79)"
          >
            <path
              id="Path_733"
              data-name="Path 733"
              d="M0,0H211.983"
              transform="translate(159.725 655)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="10"
            />
            <path
              id="Path_738"
              data-name="Path 738"
              d="M0,0H110.587"
              transform="translate(195.725 55)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeWidth="10"
            />
            <path
              id="Path_692"
              data-name="Path 692"
              d="M3921.548,5411.735a298.88,298.88,0,0,0-199.688-76.11c-1.118,0-2.229.03-3.345.043v-.043H3184.589"
              transform="translate(-2823.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="10"
            />
            <path
              id="Path_690"
              data-name="Path 690"
              d="M3887.743,5885.63c80.839-53.746,134.117-145.653,134.117-250a298.752,298.752,0,0,0-67.275-189.327"
              transform="translate(-2822.186 -5278.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="10"
            />
            <path
              id="Path_722"
              data-name="Path 722"
              d="M3677.94,5935.625h40.574v-.042c1.116.012,2.227.042,3.345.042a299.029,299.029,0,0,0,118.37-24.256"
              transform="translate(-2815.186 -5280.625)"
              fill="none"
              stroke="#3c78e6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              strokeWidth="10"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function BackgroundFingerprint() {
  return (
    <svg width="1318.199" height="1042.109" viewBox="0 0 1318.199 1042.109">
      <path
        id="Path_734"
        data-name="Path 734"
        d="M462.716,1205.941c6.881-.646,13.756-1.36,20.646-1.929a540.507,540.507,0,0,0,150.216-34.432,22.264,22.264,0,0,0,2.118-1.123c-1.989-4.3-3.914-8.458-5.877-12.7-125.892,47.185-251.726,48.08-378.1,1.508-2,4.358-3.912,8.506-6.346,13.8,20.3,6.15,39.93,12.7,59.941,18.025a499.531,499.531,0,0,0,105.561,16.064,20.21,20.21,0,0,1,3.525.792ZM881.5,640.723,867.107,644.6c-3.315-9.188-5.883-18.265-9.8-26.82-13.2-28.8-26.586-57.548-40.511-86.064a142.938,142.938,0,0,1-14.362-49.568c-1.246-13.086-.278-25.892,6.687-37.772,8.644-14.741,30-24.522,46.229-20.971-.375,4.425-.753,8.888-1.123,13.257-24.7,1.546-36.136,12.311-36.472,34.575a113.492,113.492,0,0,0,2.081,21.992c4.313,23.587,17.193,44.293,27.11,65.979,7.793,17.041,16.252,33.828,23.943,50.906,4.06,9.021,7.11,18.427,10.616,27.659ZM28.4,780.7c29.273,29.543,53.058,62.161,66.994,100.326,8.18,22.4,20.4,42.9,35.2,62.163,18.773,24.431,42.331,44.852,65.32,65.762,29.6,26.916,63.191,48.138,102.782,60.8,29.12,9.312,59.371,14.417,89.569,19.569,38.092,6.495,76.358,7.617,114.745,1.934,51.717-7.656,98.586-26.089,141.805-52.944,44.352-27.556,82.572-60.79,111.629-102.22q52.626-75.034,63.077-163.979a271.72,271.72,0,0,0-15.693-129.88c-10.345-27.4-25.517-52.629-39.837-78.291-10.975-19.672-21.789-39.4-26.95-61.347-6.659-28.325-3.856-54.979,15.589-78.568,18.668-22.645,42.577-39.648,70.982-51.068,8.255-3.319,16.9-5.81,25.827-8.833,1.541,5.373,2.787,9.713,4.128,14.386-29.09,6.791-53.071,20.847-74.312,39.3-24.29,21.11-34.4,46.238-27.994,76.928,4.128,19.787,13.052,37.695,22.674,55.462,11.282,20.829,23.412,41.3,33.843,62.478C826.6,650.9,836.922,691.144,837.218,733.2c.428,60.918-14.841,118.641-44.366,173.088-45.437,83.787-117.235,142.1-210.031,178.922a339.555,339.555,0,0,1-163.156,22.2c-27.447-2.946-54.674-7.971-81.81-12.934-48.512-8.874-92.671-26.71-130.37-56.557A655.691,655.691,0,0,1,134.6,971.242C111.156,946.1,92.542,918.2,81.02,886.711c-9.954-27.215-25.159-51.72-44.113-74.36-6.949-8.3-14.525-16.159-21.638-24.026L25.361,778.14C26.853,779.392,27.691,779.991,28.4,780.7ZM817.373,274.624A1044.418,1044.418,0,0,0,680.04,352.118c-19.814,13.191-37.268,28.688-49.97,48.171C611.7,428.454,604.9,459.227,606.094,491.7c1.473,40.283,13.918,77.57,38.527,110.946a262.569,262.569,0,0,1,39.747,79.082c10.766,34.829,14.7,70.235,7.7,106.062-10.244,52.447-36.389,97.38-78.526,134.156-28.178,24.591-60.8,42.583-98.629,51.617A289.946,289.946,0,0,1,397.9,977.33c-45.6-7.773-86.444-24.9-118.544-56.151-41.9-40.793-76.146-86.83-105.2-136.056-12.837-21.748-23.8-44.419-39.419-64.761C100.338,675.545,56.7,639.9,6.248,610.948c-1.584-.908-3.1-1.917-4.743-2.942,2.829-4.266,5.311-8,8.338-12.569C24.07,604.5,38.15,612.872,51.524,622.1c50.4,34.788,92.975,76.166,120.765,128.528,25.674,48.375,58.023,92.582,93.582,135.065,23.492,28.065,51.536,50.773,87.555,64.607,38.14,14.65,77.76,18.723,118.7,15.609,49.923-3.8,93.316-21.478,128.941-53.212,64.343-57.318,90.864-126.575,73.156-208.368-6.665-30.79-18.006-60.254-37.451-86.232-29.054-38.817-45.155-81.228-46.285-128.29-1.394-58.081,20.858-106.353,71.161-142.825,35.883-26.016,75.193-47.235,114.465-68.471,13.172-7.124,26.953-13.3,40.4-19.88a13.738,13.738,0,0,1,1.458,1.681c1.89,3.52,3.748,7.056,5.982,11.282C821.464,272.742,819.413,273.672,817.373,274.624ZM102.148,580.869c33.886,25.544,66.552,52.288,94.376,83.616,35.011,39.42,62.394,83.192,85.5,129.12,15.494,30.791,36.11,57.337,66.1,77.183,33.663,22.274,71.385,33.147,113.019,29.441,45.012-4.006,81.969-22.849,111.093-54.391,25.513-27.631,39.4-59.653,39.37-95.977-.025-29.2-8.459-56.65-24.418-82.06-4.9-7.807-9.953-15.574-14.209-23.679-29.171-55.561-48.023-113.471-48.015-175.81,0-29.876,2.19-59.31,14.567-87.37,19.874-45.057,54.028-78.843,99.122-103.362,34.886-18.966,70.524-36.772,105.846-55.064,14.131-7.319,28.313-14.557,42.826-22.014l7.618,12.473-15.683,8.141c-45.566,23.658-91.729,46.411-136.534,71.222-46.244,25.607-79.75,61.7-94.453,110.233-11.651,38.455-9.737,77.769-3.212,116.675,8.563,51.051,29.538,98.033,56.5,143.382,36.012,60.566,36.959,121.9-7.082,179.7-40.044,52.554-96.361,78.39-166.662,71.628-66.263-6.372-114.407-40.125-147.63-92.034-10.911-17.049-19.054-35.566-29.082-53.114C230.4,732.574,207.384,697.657,178,666.647c-35.5-37.463-76.327-69.561-120.049-98.59-17.643-11.714-36.094-22.4-54.482-33.749l7.608-11.781A740.563,740.563,0,0,1,102.148,580.869ZM95.882,270.474c81.833,39.5,157.41,87.549,228.328,141.77,42.159,32.234,81.122,67.584,112.616,109.025,43.9,57.765,76.571,121.315,109.89,184.438,8.782,16.639,11.37,34.831,8.876,53.312-3.874,28.737-18.923,52.1-42.836,70.426-25.6,19.618-55.288,28.238-88.457,22.273-39.061-7.023-65.975-28.978-83.947-60.851-13.695-24.288-26.688-48.926-41.076-72.861-15.437-25.676-31.006-51.36-51.06-74.424-19.8-22.768-42.607-42.9-65.178-63.265a875.311,875.311,0,0,0-133.679-99.2c-11.9-7.2-24.006-14.126-36.33-21.361,2.635-4.039,5.175-7.94,8.135-12.48,17.207,10.3,34.262,20.205,50.971,30.575,56.863,35.288,107.344,77.4,155.124,122.4,24.305,22.884,46.057,47.544,63.476,75.314,21.822,34.793,44.888,68.969,62.187,105.99,6.462,13.832,16.193,25.453,28.545,35.232,21.835,17.288,46.846,25.956,75.778,21.11,37.019-6.2,61.646-27.06,76.34-57.972,12.72-26.756,8.053-53.045-5.775-78.266-17.893-32.641-36.52-64.943-54.518-97.537A550,550,0,0,0,335.906,440.68,1290.6,1290.6,0,0,0,88.38,283.134c-8-3.886-16.027-7.718-24.289-11.693,2.374-4.329,4.521-8.242,6.979-12.727C79.7,262.8,87.822,266.583,95.882,270.474ZM64.619,438.022c55.626,28.681,107.73,61.926,151.463,104.8,30.643,30.038,59.382,61.73,88.513,93.041,17.685,19.012,32.825,39.6,43.831,62.714,9.931,20.854,21,41.251,31.533,61.866a99.333,99.333,0,0,0,28.658,33.948c12.6,9.628,26.786,15.224,43.548,12.64,14.829-2.288,26.215-10.015,35.682-20.323,16.019-17.437,22.438-36.3,14.13-59.213-10.614-29.275-23.784-57.38-42.188-83.081-20.013-27.949-41.672-54.9-62.358-82.452-29.456-39.228-60.733-76.7-99.449-109.172-66.1-55.43-138.193-102.262-218.906-137.882-9.116-4.022-18.326-7.867-27.7-11.884,2.149-4.5,4.118-8.627,6.174-12.932,2.151.837,3.785,1.444,5.393,2.1q137.177,56.234,246.287,150.975C333.04,463.8,356.8,484.381,375.767,509.15c28.774,37.578,58.22,74.729,86.708,112.488,25.275,33.5,45.079,69.6,56.293,109.215,2.2,7.765,3.356,16.388,2.138,24.242-3.82,24.623-18.7,43.487-41,56.875-23.33,14-47.648,13.466-71.27.067-15.793-8.958-28.448-21.111-37.2-36.092-9.528-16.3-18.654-32.864-26.753-49.8C331.933,699.5,318.6,673.3,297.829,650.879c-12.507-13.5-24.326-27.555-37.2-40.751-23.951-24.562-47.328-49.727-72.966-72.746-42.965-38.574-93.015-68.495-145.9-94.469-6.577-3.231-13.2-6.376-20.222-9.763L28.7,420.3C41.084,426.4,52.972,432.016,64.619,438.022Zm785.006-27.648c-6.9,1.664-14.027,2.793-20.654,5.117-28.108,9.851-41.634,28.9-41.742,58.639-.083,22.813,7.829,43.854,18.227,64.164,8.726,17.046,18.531,33.635,26.979,50.791,19.968,40.553,32.263,82.862,34.249,127.591,1.84,41.432,1.291,82.652-8.883,123.306-13.076,52.239-35.53,100.552-71.544,143.177-22.2,26.276-49.451,47.692-77.33,68.618-81.236,60.977-174.5,89.281-279.076,86.652a453.768,453.768,0,0,1-172.164-38.467c-2.488-1.09-4.916-2.292-7.455-3.48,2.037-3.784,3.768-7.02,5.524-10.241.4-.722.888-1.4,1.435-2.244,1.1.411,2.1.725,3.043,1.147,71.684,32.043,147.21,44.6,226.555,37.192a423.518,423.518,0,0,0,133.854-34.919c35.356-15.756,66.057-37.634,96.376-60.246C790.686,972.227,831.071,900.3,846.967,815.681c5.152-27.423,5.351-55.135,4.713-82.893-.761-33.132-5.1-65.685-16.455-97.286-10.934-30.451-26.116-59.142-41.985-87.635-13.019-23.381-21.845-48.052-21.483-74.847.341-25.2,8.876-46.741,32.277-61.64,13.875-8.836,29.406-13.717,46.682-15.369.575,4.812,1.094,9.151,1.663,13.913C851,410.146,850.3,410.211,849.625,410.374ZM313.3,891.3c39.905,28.892,85.048,44.3,136.107,42.216,69.012-2.814,124.359-29.7,162.219-83.227,32.272-45.627,42.1-95.283,24.268-148.07a595.847,595.847,0,0,0-46.574-103.388c-23.374-41.2-34.371-84.921-32.553-131.219,1.522-38.791,14.015-74.4,39.345-105.845,16.506-20.489,37.35-36.959,58.536-53.17,43.8-33.516,91.133-61.653,144.357-81,1.771-.643,3.581-1.2,5.725-1.909l5.376,12.829c-13.1,5.45-25.726,10.422-38.09,15.9-50.415,22.316-94.15,53.387-135.358,87.648-27.19,22.606-47.207,49.63-56.766,82.422-16.213,55.624-7.366,109.2,19.425,160.143,14.839,28.221,28.723,56.722,41.314,85.785,10.6,24.477,19.031,49.622,19.361,76.2.686,55.3-19.437,103.962-62.421,142.5-64.881,58.167-142.142,72.5-228.157,47.172-26.66-7.849-50.148-21.268-71.889-38.314l10.161-10.734C309.7,888.7,311.5,890,313.3,891.3Zm-69.1,111.957q95.1,61.637,211.712,58.369c65.953-1.874,126.726-19.187,180.877-53.978C712.7,958.888,756.826,890.621,778.956,808.8l14.481,2.786a16.1,16.1,0,0,1-.169,2.489c-17.827,69.061-52.48,129.853-110.184,177.594-93.916,77.7-204.547,101.385-326.166,74.162-115.351-25.822-196.613-91.9-246.13-190.723-5.025-10.028-8.872-20.549-13.4-31.149l15.061-4.568C137.618,907.2,180.807,962.17,244.2,1003.262Zm397.758-21.707c-11.743,7.474-23.153,15.466-35.373,22.222-47.711,26.379-99.246,41.786-155.211,43.071-63.5,1.459-122-14.612-175.415-45.453-64.165-37.051-109.957-89.135-139.3-152.69C110.82,792.731,73.4,745.154,23.69,705.371c-5.879-4.7-11.92-9.237-18.078-14l10.041-11.483c12.278,10.038,24.494,19.4,35.944,29.5,37.608,33.161,68.823,70.709,89.9,114.7,14.049,29.317,28.976,57.963,49.78,83.989,36.784,46.018,82.165,81.857,140.157,103.492,51.828,19.337,105.244,26.427,160.725,17.152,51.862-8.671,98.088-28.721,139.684-58.133,1.913-1.353,3.825-2.707,5.833-4.128,3,3.339,5.623,6.239,8.225,9.152.434.487.792,1.031,1.444,1.891C645.5,978.9,643.835,980.362,641.961,981.555Zm-78.635-286.2c-7.247-17.164-16.616-33.737-26.669-49.711-21.882-34.771-43.452-69.815-67.633-103.238C435.288,495.77,393.7,454.965,349.789,416.2c-74.437-65.7-157.57-120.362-248.815-164.712-8.95-4.351-17.947-8.622-27.131-13.03l7-12.528c1.588.694,2.716,1.168,3.826,1.675a1150.277,1150.277,0,0,1,116.983,61.834A1092.839,1092.839,0,0,1,364.617,409.324c42.4,37.827,83.214,77.21,115.506,122.686C510.9,575.356,538.6,620.59,566.484,665.6c17.309,27.936,23.564,58.893,23.073,90.938-.108,7.128-.791,14.247-1.233,21.725l-15.62-1.694C576,748.326,574.21,721.121,563.326,695.353ZM739.786,380.681C686.32,418.8,666.106,480.96,689.584,539.2c5.6,13.894,14.116,26.806,21.383,40.128A436.215,436.215,0,0,1,761,734.561c3.078,24.188,3.467,48.4-1.422,72.527-7.514,37.1-24.48,70.455-48.074,101.031-10.383,13.456-22.012,26.106-33.375,39.476l-12.039-10.27c2.191-2.314,4.184-4.184,5.889-6.255,11.949-14.513,24.705-28.548,35.562-43.722,19.724-27.562,32.97-57.684,37.976-90.564,3.592-23.6,2.226-47.138-1.429-70.6-8.387-53.862-25.52-105.146-54.478-152.828-12.933-21.3-22.419-43.57-24.4-68.082-3.541-43.921,8.609-83.529,41.659-116.075,27.262-26.845,60.553-46.367,97.393-60.614,10.283-3.977,20.955-7.1,31.952-10.79,1.625,5.194,2.94,9.392,4.461,14.251C802.815,341.659,770.129,359.046,739.786,380.681ZM42.507,938.427a387.668,387.668,0,0,0,47.842,70.946c25.651,30.538,54.487,58.164,91.6,76.83,26.412,13.284,54.363,23.969,81.468,36.113,71.219,31.912,146.17,40.143,224.1,30.347,32.694-4.11,64.3-12.335,95.917-20.58,30.768-8.021,60.3-18.526,86.3-36.108,3.973-2.685,7.934-5.385,12.123-8.23,3.346,3.824,6.436,7.356,9.674,11.055-18.713,13.838-38.291,25.656-60.359,33.247-56.416,19.405-114.119,33.962-174.632,37.692-48.818,3.009-97.122.189-143.509-14.407-30.661-9.648-60.217-22.323-90.036-34.136-28.59-11.328-56.314-24.182-80.815-42.2-44.668-32.844-78.431-73.776-105.656-119.562-3.637-6.116-6.846-12.447-10.4-18.939,5.022-2.148,9.36-4.006,14.051-6.012C41.161,936.136,41.9,937.253,42.507,938.427ZM398.094,719.01c5.409,10.783,9.06,22.352,12.923,33.733,5.181,15.274,20.144,24.565,35.83,21.68,15.965-2.936,27.147-17.013,24.545-32.664a67.9,67.9,0,0,0-8.017-22.193c-9.714-16.962-20.881-33.223-30.7-50.136-35.473-61.075-81.4-115.287-131.325-166.653-42.23-43.449-91.645-79.49-144.722-111.3-9.547-5.721-19.278-11.184-29.331-17,2.709-4.174,5.276-8.131,8.007-12.335,74.183,41.534,141.368,89.517,196.338,150.731,23.182,25.814,47.368,51.2,67.3,79.062,28.087,39.277,52.777,80.607,78.558,121.251,3.8,5.991,6.3,12.882,8.2,19.64,5.909,21.052-3.467,41.837-22.475,51.186-27.626,13.587-59.862-.144-67.652-29.216a152.042,152.042,0,0,0-16.441-38.789c-5.551-9.3-11.414-18.445-17.311-27.935l13.4-7.982C383.141,693.406,391.487,705.84,398.094,719.01ZM716.57,142.326C666.535,168.7,616.77,195.513,566.4,221.34c-50.82,26.058-105.694,33.055-162.914,25.776-42.129-5.358-80.112-21.129-116.472-40.554-31.489-16.823-62.69-34.1-94.3-50.733-14.058-7.4-28.8-13.705-43.622-20.691,2.3-4.271,4.534-8.407,7.429-13.778,34.342,17.529,68.351,34.234,101.634,52.076,28.212,15.123,55.281,32.017,85.792,43.347,75.53,28.05,149.335,25.626,220.84-10.971,40.876-20.919,81.109-42.892,121.668-64.332,13.886-7.338,27.885-14.494,42.079-21.861,2.59,4.229,4.933,8.057,7.649,12.491C729.267,135.714,722.9,138.99,716.57,142.326ZM496.794,992.3c67-9.056,123.065-36.91,161.874-87.97,68.148-89.665,75.506-185.374,25.945-284.568-7.313-14.637-17.366-28.123-26.434-42.592l11.716-7.8c1.882,2.414,3.7,4.42,5.128,6.634,7.934,12.246,16.7,24.127,23.49,36.893C733.061,677.9,740.691,745.815,721.3,815.8c-13.679,49.379-39.023,93.218-79.887,128.55-43.291,37.433-95.118,57.867-154.047,63.526-9.137.877-18.366.95-27.733,1.4V995.448C472.314,994.4,484.649,993.937,496.794,992.3ZM685.62,228.023c-3.607,2.69-7.157,5.452-10.874,8.009-81.181,55.851-171.912,82.554-273.619,73.766-48.294-4.172-93.765-17.484-134.8-41.817-45.842-27.183-93.066-52-143.126-72.117-5.347-2.149-10.688-4.313-16.284-6.573,2.158-4.548,4.114-8.673,6.176-13.018,2.366.915,4.164,1.607,5.955,2.307a987.468,987.468,0,0,1,148.984,73.475c53.743,32.247,112.992,46.559,176.876,45.117,68.236-1.539,131.187-19.616,188.975-52.677,14.825-8.482,28.764-18.263,43.462-27.673,2.8,3.109,5.936,6.586,8.925,9.906C685.916,227.456,685.86,227.843,685.62,228.023ZM432.925,744.072A774.17,774.17,0,0,0,367.71,636.852C327.742,581.653,280.1,532.5,227.968,486.763c-55.338-48.552-116.4-89.411-185.9-119.3-3.356-1.443-6.695-2.916-10.413-4.536,1.226-2.448,2.256-4.5,3.278-6.551s2.024-4.094,3.1-6.267c1.56.564,2.732.928,3.85,1.4a709.783,709.783,0,0,1,103.731,54.218c47.721,30.3,89.913,66.409,130.252,104.438,67.238,63.386,122.41,134.577,164.313,214.309,3.456,6.577,6.758,13.224,10.26,20.088l-14.156,5.862C434.938,747.885,433.891,746,432.925,744.072ZM186.082,99.556c48.3,21.782,95.437,45.53,141.093,71.648,29.181,16.692,60.477,27.289,94.6,30.79,29.415,3.017,58.411,1.378,85.556-10.276,23.437-10.062,46.645-20.708,69.217-32.3,42.559-21.859,84.586-44.588,126.844-66.941,1.777-.941,3.656-1.727,5.712-2.69,2.612,4.367,4.9,8.2,7.411,12.392-2.206,1.136-4.039,2.072-5.865,3.022-21.134,11-42.427,21.754-63.368,33.056-39.113,21.109-78.113,42.361-118.913,60.72-23.433,10.545-47.766,17.449-73.911,18.288-46.4,1.49-89.317-8.915-129.5-30.466-41.938-22.489-84.58-43.875-126.986-65.626-7.9-4.051-16.136-7.545-24.5-11.427,2.346-4.33,4.481-8.264,6.878-12.689C182.575,98.024,184.34,98.77,186.082,99.556ZM104.013,204.5c47.029,15.889,91.5,36.376,131.923,63.646a1474.433,1474.433,0,0,1,209.2,170.949c28.778,28.276,55.206,58.135,71.9,94.191,4.16,8.99,8.08,18.072,12.333,27.606L514.389,565.6c-.889-2.119-1.6-3.776-2.285-5.439-8.864-21.517-19.306-42.307-33.678-61.271-19.261-25.417-42.064-48.069-65.595-70.116A1615.687,1615.687,0,0,0,267.273,308.057c-41.7-30.78-85.631-58.072-134.926-77.61-12.419-4.923-25.037-9.42-37.925-14.25,1.621-4.192,3.213-8.306,5.022-12.986C101.348,203.743,102.706,204.055,104.013,204.5Zm17.541,535.729C148.658,773.471,170.3,809.57,190,846.776c13.514,25.521,30.262,49.009,52.226,69.229,33.975,31.276,74.59,52.62,119.577,67.329,15.433,5.047,31.236,9.134,47.324,13.79-1.135,4.157-2.323,8.519-3.547,13-1.506-.205-2.568-.265-3.579-.5a466.834,466.834,0,0,1-78.784-25.23c-48.341-20.683-90.393-48.9-120.447-89.781-14.511-19.734-26.437-41.2-38.1-62.541Q111.358,734.465,21.638,663c-6.3-5.012-12.707-9.917-19.3-15.053L11.861,637C44.479,658.754,92.07,704.059,121.553,740.225ZM783.3,773.76c-.929-22.586-1.341-45.2-2.9-67.749-1.471-21.3-4.894-42.335-14.8-62.073-5.3-10.552-9.711-21.474-14.713-32.155-9.29-19.843-17.414-40.271-28.475-59.254-9.987-17.136-18.081-34.094-17.4-53.83.6-17.517-.211-35.176,1.972-52.523,2.9-22.994,17.972-40.625,34.86-56.861,20.156-19.377,45.2-31.892,71.688-42.193,9.428-3.665,19.235-6.507,29.3-9.868,1.605,5.355,2.9,9.673,4.128,13.762a6.237,6.237,0,0,1-.961.663c-1.871.541-3.762,1.019-5.616,1.6-33.446,10.531-64.92,24.148-89.618,48.315-16.521,16.167-29.143,34.143-29.928,57.168-.447,13.11-.186,26.24-.364,39.359-.214,15.846,4.021,30.451,13.776,43.664a59.994,59.994,0,0,1,6.263,10.293c9.548,20.639,19.037,41.3,28.287,62.055,6.681,14.99,13.993,29.836,19.173,45.27,7.938,23.662,8.8,48.436,10.175,72.975.8,14.351.146,28.77.146,43.421H783.8A13.557,13.557,0,0,1,783.3,773.76ZM204.626,626.786c15.584,17.767,31.061,35.614,46.767,53.291,21.175,23.833,38.676,49.426,48.765,79.1,8.846,26.02,25.229,48.31,43.26,69.713,50.656,60.13,158.445,58.315,205.487-9.021,2.869-4.11,5.572-8.32,8.512-12.721l13.7,6.163a138.6,138.6,0,0,1-35.327,42.041c-24.949,20.119-54.34,29.6-87.26,30.825-38.375,1.431-72.766-8.234-100.863-32.565-28.66-24.818-49.388-54.866-61.981-89.118a213.425,213.425,0,0,0-40.8-68.636c-9.241-10.445-18.3-21.024-27.471-31.524-8.926-10.221-17.887-20.418-27.042-30.867,4.171-3.038,7.936-5.779,12.151-8.848C203.47,625.593,204.082,626.166,204.626,626.786ZM759.469,156.43c-24.409,11.967-49.177,23.359-73.121,36.063-31.089,16.5-61.348,34.306-92.276,51.066-45.677,24.751-95.248,37.065-148.3,36.692-64.241-.452-123.155-17.515-177.126-49.257a24.056,24.056,0,0,1-2.741-2.205c2.872-3.936,5.548-7.6,8.324-11.4,1.489.8,2.734,1.418,3.918,2.121a323.993,323.993,0,0,0,60.175,27.842c57.249,19.694,115.687,24.232,175.41,11.239,34.9-7.594,65.871-23.288,96.309-39.964,37.432-20.508,74.682-41.3,112.281-61.545,10.858-5.845,22.654-10.225,34.528-15.5,2.3,4.792,4.278,8.9,6.338,13.188C761.682,155.439,760.554,155.9,759.469,156.43ZM647.245,63.906c-21.875,11.742-43.666,23.621-65.7,35.1-20.636,10.748-41.972,20.423-62.167,31.811-12.043,6.791-24.159,12.834-37.908,15.479-12.2,2.348-24.569,4.652-36.968,5.3-34.241,1.794-65.811-5.215-93.414-25.166-28.607-20.676-59.94-37.4-93.04-51.319-8.233-3.461-16.583-6.688-25.159-10.135,1.948-4.476,3.781-8.692,5.661-13.014,1.051.342,1.713.533,2.354.77a524.576,524.576,0,0,1,113.956,58.138c8.033,5.447,16.007,11.239,24.843,15.367,24.914,11.636,51.646,13.547,78.908,9.822,16.092-2.2,31.808-5.639,46.057-13.626,17.965-10.07,35.9-20.314,54.631-29.077,28.518-13.341,56.917-26.736,83.072-43.791a17.154,17.154,0,0,1,2.506-1.08c2.885,3.752,5.635,7.329,8.734,11.357C651.045,61.492,649.235,62.839,647.245,63.906ZM349.806,648.315l-12.579,6.864c-7.923-11.144-15.242-22.019-23.173-32.5-40.473-53.492-86.08-102.76-142.9-142.383-44.367-30.939-92.831-55.929-141.861-80-2-.98-3.972-2-6.146-3.1,2.463-4.357,4.668-8.259,6.57-11.626C165.555,443.583,274.594,528.517,349.806,648.315ZM11.739,562.139C42.7,579.6,72.555,598.5,100.59,619.742c34.905,26.444,67.059,55.334,91.849,90.363,28.549,40.336,52.879,82.85,75.895,126.008,4.135,7.751,8.082,15.587,12.282,23.707-5,2.1-9.46,3.964-14.157,5.933-1.055-1.986-1.791-3.454-2.6-4.886-20.081-35.471-39.79-71.124-60.365-106.352-20.291-34.739-45.221-66.446-76.391-93.845a653.265,653.265,0,0,0-83.132-62.05C29.561,589.538,14.813,580.909,0,571.942c2.556-3.886,5.128-7.792,7.774-11.813C9.279,560.888,10.542,561.464,11.739,562.139ZM571.1,314.885c-1.671,1.231-3.368,2.432-5.026,3.677-23.74,17.828-42.11,39.219-51.364,66.4-6.916,20.313-7,41.351-6.832,62.367.05,6.382.68,12.829-.094,19.128-.956,7.8-10.007,10.732-16.544,5.666a29.446,29.446,0,0,1-5.811-6.377c-5.916-8.4-11.125-17.25-17.531-25.312q-51.989-65.442-125.247-110.776c-1.59-.988-3.148-2.024-5.042-3.246,2.943-4.078,5.672-7.856,8.615-11.934,57.824,35.479,106.643,78.779,145.865,132.847.3-28.608.836-56.13,13.814-81.737,12.917-25.487,32.274-46.033,56.959-62.876,3.2,4.071,6.014,7.648,8.909,11.331A6.876,6.876,0,0,1,571.1,314.885ZM615.747,43.754a954.474,954.474,0,0,0-86.01,48.055c-26.7,16.607-55.826,28.731-88.563,31.371-24.634,1.985-47.153-2.717-66.109-18.538C351.752,85.185,325.356,69.9,296.816,57.729c-7.557-3.223-15.269-6.14-22.974-9.224,1.028-2.464,1.9-4.61,2.818-6.739.891-2.071,1.829-4.124,2.768-6.231,1.523.481,2.55.766,3.543,1.125,37.09,13.374,71.272,31.37,100.8,55.968,18.069,15.051,38.855,18.611,61.726,15.693,27.62-3.523,52.09-14.555,75.337-28.118,20.349-11.872,40.533-23.984,61.013-35.659,9.353-5.333,19.243-9.871,29.265-14.959,2.536,4.422,4.759,8.3,7.254,12.643C617.236,42.89,616.522,43.376,615.747,43.754Zm27.105,495.354c-.436-.9-.857-1.8-1.239-2.714-13.6-32.472-15.843-65.767-7.667-99.565,8.22-33.985,26.969-61.6,59.078-81.322a641.107,641.107,0,0,1,89.185-45.842c14.259-5.938,28.793-11.326,43.618-17.126,2.018,4.97,3.734,9.2,5.547,13.663-2.213.832-3.994,1.535-5.8,2.175-40.28,14.3-78.779,31.829-114.868,53.645-15.7,9.493-31.094,19.417-41.482,34.367C644.8,431.554,640.256,469.733,649.2,509.793c1.913,8.569,5.265,16.866,8.043,25.566l-13.429,5.115A14.028,14.028,0,0,1,642.852,539.108ZM216.215,74.687c42.9,21.092,83.423,45.673,124.152,70.05,46.841,28.034,97.892,33.791,151.45,18.617,8.446-2.393,16.533-5.861,25.037-8.924,2.223,4.074,4.41,8.085,6.679,12.245-2.127,1-3.667,1.823-5.286,2.479-64.229,26.058-126.661,22.075-185.726-12.065-38.551-22.284-76.089-46.024-116.212-65.974-4.512-2.243-8.987-4.546-13.658-6.91,2.5-4.252,4.771-8.119,7.323-12.461C212.437,72.9,214.344,73.767,216.215,74.687ZM111.222,973q46.384,53.376,107.886,92c-1.784,2.437-3.15,4.35-4.569,6.232-1.377,1.829-2.807,3.626-4.373,5.638C123.83,1021.77,61.6,950,22.676,860.731l14.6-5.263A450.437,450.437,0,0,0,111.222,973ZM475.8,392.957c-5.368,2.082-9.771.092-13.439-3.54a75.749,75.749,0,0,1-6.194-6.774,139.512,139.512,0,0,0-53.481-41.515c-3.163-1.414-6.669-3.1-8.632-5.58-1.73-2.183-2.783-6.095-1.815-8.438.96-2.322,4.575-4.34,7.476-5.186,2.687-.784,6.044-.157,8.984.4,25.927,4.883,51.718,6.044,77.305-1.735,6.609-2.008,13.217-4.082,19.956-5.653,4.635-1.079,9.189-.243,11.29,4.347,2.032,4.44-.036,8.02-4.05,10.667-3.624,2.391-7.419,4.565-11.1,6.881-15.852,9.967-23.745,23.239-20.344,41.21a36.636,36.636,0,0,1,.3,3.772C482.137,386.3,481.307,390.822,475.8,392.957Zm-10.4-24.4a46.573,46.573,0,0,1,11.668-29.981l-42.415,2.441Q449.286,354.115,465.408,368.556ZM492.461,40.174c-15.353,7.652-30.9,15.052-46.823,21.636-13.6,5.624-26.663,4.07-38.424-5.3-7.407-5.9-15.5-11.092-23.435-16.414-10.344-6.938-20.833-13.693-31.587-20.739L360.9,7.731c1.832,1.1,3.359,1.923,4.78,2.878,17.584,11.828,35.295,23.5,52.646,35.605,6.374,4.447,12.665,5.684,19.939,2.878,5.591-2.156,11.37-4.014,16.663-6.68C478.564,30.5,502.06,18.363,525.595,6.28,529.456,4.3,533.245,2.2,537.354,0c2.7,4.126,5.163,7.9,8.11,12.408C527.494,21.863,510.172,31.348,492.461,40.174ZM17.555,485.054A762.315,762.315,0,0,1,174.3,595.425c-3.846,3.552-7.316,6.759-9.971,9.211C139.6,585.377,115.85,565.4,90.395,547.461c-25.6-18.046-52.9-34.07-79.913-51.272Zm551-451.585a195.328,195.328,0,0,0-56.991,33.543c-21.417,18.285-46.9,25.736-75.818,23.2A89.567,89.567,0,0,1,392.822,74.7l9.022-11.4c1.251.7,2.014,1.109,2.762,1.543,30.657,17.806,67.461,15.043,94.758-6.988,6.837-5.518,13.728-11.028,21.034-16A196.839,196.839,0,0,1,566.2,19c1.926,4.4,3.7,8.458,5.691,13C570.436,32.646,569.517,33.1,568.559,33.469Zm-23.97,121.748c-2.248-3.325-4.834-7.153-8.248-12.2L680.886,69.168c2.958,5.227,5.234,9.246,7.235,12.779C640.2,106.41,592.646,130.684,544.589,155.217ZM233.154,193.089c-2.6,4.429-4.943,8.4-7.435,12.634-32.967-16.129-65.473-32.028-98.194-48.034,2.511-4.343,4.755-8.22,7.34-12.688ZM88.588,801.465c-4.4,3.185-8.152,5.9-12.287,8.895L7.525,730.776c4.131-3.008,7.879-5.739,12.274-8.941C42.9,748.578,65.673,774.937,88.588,801.465Zm748.478-276.1c-2.466-11.394-5.037-21.747-6.875-32.208a235.473,235.473,0,0,1-3.406-27.784c-.386-7.068,4-12.189,11.259-14.633,8.071-2.717,16.082-1.632,24.336,1.095-1.78,4.447-3.418,8.543-4.964,12.407a5.836,5.836,0,0,1-1.45.37c-1.065-.107-2.126-.266-3.176-.458-10.092-1.835-11.854-.458-10.255,8.628,2.645,15.021,5.493,30.011,8.363,45.6ZM432.964,34.824c-16.417-1.861-32.1-13.374-35.558-26.366l13.531-4.983c12.251,21.723,37.726,23.15,53.782,2.249,4.281,2.244,8.582,4.5,12.862,6.745C469.242,27.38,450.25,36.784,432.964,34.824ZM778,184.884,717.365,210.4c-2.305-4.66-4.324-8.736-6.459-13.052l60.728-25.59C773.912,176.46,775.9,180.554,778,184.884Zm-49.354,894.9-11.552-9.721c15.331-13.545,30.479-26.929,44.709-39.5l12.126,9.216Q750.419,1060.548,728.647,1079.784ZM91.529,355.319l-50.8-27.067c2.66-4.21,5.139-8.129,7.843-12.405,17.058,9.079,33.7,17.935,50.928,27.106Zm265.4-302.1L304.386,32.1c2.3-4.73,4.249-8.722,6.365-13.061l52.467,21.058C361.053,44.609,359.078,48.728,356.925,53.222Z"
        transform="translate(123.401 1041.321) rotate(-98)"
        fill="#f7f5f2"
        stroke="rgba(0,0,0,0)"
        strokeWidth="1"
        opacity="0.05"
      />
    </svg>
  );
}

export function PlayerPlay(props: any) {
  let color = props.color ? props.color : "#354499";
  return (
    <svg width="17.791" height="21.349" viewBox="0 0 17.791 21.349">
      <path
        id="if_icon-play_211876"
        d="M113.191,73.39,97.712,64.178A1.167,1.167,0,0,0,97.106,64a1.109,1.109,0,0,0-1.1,1.112H96V84.237h.006a1.109,1.109,0,0,0,1.1,1.112,1.272,1.272,0,0,0,.623-.189l15.462-9.2a1.674,1.674,0,0,0,0-2.569Z"
        transform="translate(-96 -64)"
        fill={color}
      />
    </svg>
  );
}

export function PlayerPause(props: any) {
  let color = props.color ? props.color : "#354499";
  return (
    <svg width="17.792" height="21.35" viewBox="0 0 17.792 21.35">
      <g id="pause" transform="translate(-42.667)">
        <g id="Group_2" data-name="Group 2" transform="translate(42.667)">
          <g id="Group_1" data-name="Group 1" transform="translate(0)">
            <path
              id="Path_1"
              data-name="Path 1"
              d="M48.449,0H44a1.336,1.336,0,0,0-1.334,1.334V20.016A1.336,1.336,0,0,0,44,21.35h4.448a1.336,1.336,0,0,0,1.334-1.334V1.334A1.336,1.336,0,0,0,48.449,0Z"
              transform="translate(-42.667)"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_4" data-name="Group 4" transform="translate(53.342)">
          <g id="Group_3" data-name="Group 3">
            <path
              id="Path_2"
              data-name="Path 2"
              d="M304.449,0H300a1.336,1.336,0,0,0-1.334,1.334V20.016A1.336,1.336,0,0,0,300,21.35h4.448a1.336,1.336,0,0,0,1.334-1.334V1.334A1.336,1.336,0,0,0,304.449,0Z"
              transform="translate(-298.667)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function PlayerSound(props: any) {
  let color = props.color ? props.color : "#354499";
  return (
    <svg width="26.558" height="21.35" viewBox="0 0 26.558 21.35">
      <g id="sound" transform="translate(0 -50.2)">
        <path
          id="Path_3"
          data-name="Path 3"
          d="M420.8,92.933a.778.778,0,0,0,0,1.1,10.1,10.1,0,0,1,0,14.283.778.778,0,1,0,1.109,1.092,11.655,11.655,0,0,0-.008-16.476A.778.778,0,0,0,420.8,92.933Z"
          transform="translate(-398.754 -40.3)"
          fill={color}
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M378.377,146.341a.778.778,0,1,0,1.1,1.1,8.545,8.545,0,0,0,0-12.083.778.778,0,0,0-1.1,1.1,6.989,6.989,0,0,1,0,9.883Z"
          transform="translate(-358.535 -80.524)"
          fill={color}
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M335.948,185.469a.778.778,0,0,0,1.1,0,5.432,5.432,0,0,0,0-7.682.778.778,0,0,0-1.1,1.1,3.875,3.875,0,0,1,0,5.481A.778.778,0,0,0,335.948,185.469Z"
          transform="translate(-318.306 -120.753)"
          fill={color}
        />
        <path
          id="Union_1"
          data-name="Union 1"
          d="M13.58,21.165,5.475,16.7H.778A.8.8,0,0,1,0,15.879V5.486a.8.8,0,0,1,.778-.824H5.446L13.58.185a1.47,1.47,0,0,1,2.179,1.288v18.4a1.467,1.467,0,0,1-2.179,1.288Z"
          transform="translate(0 50.2)"
          fill={color}
        />
      </g>
    </svg>
  );
}

export function PlayerMute(props: any) {
  let color = props.color ? props.color : "#354499";
  return (
    <svg width="24.042" height="24.042" viewBox="0 0 24.042 24.042">
      <g
        id="Group_5"
        data-name="Group 5"
        transform="translate(-152.211 -49.855)"
      >
        <g id="sound" transform="translate(148.126 2)">
          <path
            id="Union_1"
            data-name="Union 1"
            d="M13.58,21.165,5.475,16.7H.779A.8.8,0,0,1,0,15.88V5.486a.8.8,0,0,1,.779-.824H5.5v.049l10.256,9.8,0,5.367a1.472,1.472,0,0,1-1.472,1.473A1.457,1.457,0,0,1,13.58,21.165Z"
            transform="translate(5 49.2)"
            fill={color}
          />
        </g>
        <rect
          id="Rectangle_1"
          data-name="Rectangle 1"
          width="2"
          height="32"
          rx="1"
          transform="translate(152.211 51.269) rotate(-45)"
          fill={color}
        />
        <path
          id="Path_8"
          data-name="Path 8"
          d="M160.427,54.882l8.538,8.693s.008-9.628,0-11.57-1.631-.946-1.631-.946Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
